import React from 'react'
import classNames from 'classnames'
import { IconSparkles } from '@tabler/icons-react'

import { LightningBoltIcon } from '@/components/icons/LightningBoltIcon'

import './PageHeader.scss'

export const PageHeader = ({
  title,
  description,
  actions,
  breadcrumbs,
  className,
  decoration = null,
  isDataGrid = false,
  ...props
}) => {
  return (
    <header
      className={classNames('page-header', { 'data-grid-header': isDataGrid }, className)}
      {...props}
    >
      <div className="page-header__content">
        {breadcrumbs}
        {title && (
          <h1 className="page-header__title">
            {decoration === 'lightning-bolt' && <LightningBoltIcon />}
            {decoration === 'ai' && <IconSparkles className="status-magical" />}
            {title}
          </h1>
        )}
        {description && (
          <p className="page-header__description" data-testid="page-header-description">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  )
}
